import React from 'react';
import { Field as FormField, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from '../../../types';
import { isValidGlobalBehaviour } from '../../../utils/validation';

const required = value => (isValidGlobalBehaviour(value, 'cardNo') ? undefined : 'Required');

const CardNumber = ({ maxAccountLength }) => (
  <Content>
    {({ oldCardNumberLabel, oldCardNumberValidationMessage, oldCardNumberHelpText }) => (
      <Field name="cardNumber" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <FormField>
            <FieldHeader
              name="cardNumber"
              hasError={touched && !!error}
              title={oldCardNumberLabel}
              validationMessage={oldCardNumberValidationMessage}
              description={oldCardNumberHelpText}
            />
            <FieldBody hasError={touched && !!error}>
              <Field name="cardNumber" type="input" validate={required}>
                {({ input }) => <Input type="tel" {...input} maxLength={maxAccountLength} />}
              </Field>
            </FieldBody>
          </FormField>
        )}
      </Field>
    )}
  </Content>
);

CardNumber.propTypes = {
  maxAccountLength: PropTypes.number
};

CardNumber.defaultProps = {
  maxAccountLength: 16
};

export default CardNumber;
